import React, { useContext, useEffect } from "react";
import { LanguageContext } from "../../context/LanguageContext";

const Partners = () => {
  const { componentLanguageData, loadLanguageFile, language } = useContext(LanguageContext);

  useEffect(() => {
    loadLanguageFile("Partners", "home/home_Partners_lang");
  }, [language]);

  const LANGUAGE = componentLanguageData.Partners || { Main: {} };

  const partnerData = [
    {
      image: "../../../img/partners1.png",
      title: LANGUAGE.Main.Partner1Title,
      subtitle: LANGUAGE.Main.Partner1Subtitle,
      link: "https://www.ivsr.org.tw/ksp/firm_all/article/51996?dirid=3",
      delay: "0.1s"
    },
    {
      image: "../../../img/partners2.png",
      title: LANGUAGE.Main.Partner2Title,
      subtitle: LANGUAGE.Main.Partner2Subtitle,
      link: "https://www.startupterrace.tw/Default.aspx",
      delay: "0.3s"
    }
  ];

  return (
    <div className="container-xxl py-5">
      <div className="container">
        <div className="text-center mx-auto" style={{ maxWidth: "500px" }}>
          <h1 className="display-6 mb-5">{LANGUAGE.Main.SectionTitle}</h1>
        </div>

        <div className="row g-4 justify-content-center">
          {partnerData.map((partner, index) => (
            <div
              className="col-lg-3 col-md-6 wow fadeInUp"
              data-wow-delay={partner.delay}
              key={index}
            >
              <div className="partner-item rounded">
                <img className="img-fluid" src={partner.image} alt={partner.title} />
                <div className="text-center p-4">
                  <h5>{partner.title}</h5>
                  <span>{partner.subtitle}</span>
                </div>
                <div className="partner-text text-center bg-white p-4">
                  <h5>{partner.title}</h5>
                  <p>{partner.subtitle}</p>
                  <div className="d-flex justify-content-center">
                    <a
                      className="btn btn-square btn-light m-1"
                      href={partner.link}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab bi-arrow-right"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Partners;
